import type { PlatformPlugin } from "@acto/taskpane/core/platform/PlatformPlugin";
import type { PlatformEnv } from "./env";

const NoopPlugin: PlatformPlugin<void> = {
  name: "noop",
  canBoot: async () => true,
  async boot() {
    return undefined;
  },
};

/**
 * Returns the first plugin that reports it can boot in the provided environment,
 * or a no-op fallback plugin when none match.
 */
export async function detectPlatform(plugins: PlatformPlugin[], env: PlatformEnv): Promise<PlatformPlugin> {
  for (const plugin of plugins) {
    try {
      const canBoot = await plugin.canBoot(env);
      if (canBoot) {
        return plugin;
      }
    } catch {
      // ignore plugin errors and continue
    }
  }

  return NoopPlugin;
}
